import React, { useEffect, useRef, useState } from 'react'
import { Button, Col, Container, Row } from 'reactstrap'
import { AiOutlinePlusCircle } from "react-icons/ai";
import { BsToggles } from "react-icons/bs";
import { useSelector } from 'react-redux';
import { numberWithCommas } from '../../utils/customFunction';
import { Modal } from "react-bootstrap";
import { VscSplitVertical } from "react-icons/vsc";
import {
    FaCaretUp,
    FaCaretDown,
} from "react-icons/fa";
import { getFundByAmc } from '../../stores/services/funds.service';
import { useHistory } from 'react-router-dom';
import Config from '../../config';
function Profile() {
    const history = useHistory()
    const [changeView, setChangeView] = useState("Horizontal")
    const [screen, setScreen] = useState<any>()
    const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);
    const selectedFund = useSelector((state: any) => state.FundValueReducer?.fund_value);
    const [psxList, setPsxList] = useState<any>([]);
    const [allData, setAllData] = useState<any>([]);
    const [progreesBarFlag, setProgreesBarFlag] = useState<boolean>(false)
    const [progressBarData, setProgressBarData] = useState<any>();
    const itemsPerPage = 10
    const [itemsToShow, setItemsToShow] = useState(10);
    const [searchCompany, setSearchCompany] = useState("")
    const [loading, setLoading] = useState<boolean>(false)
    const [returnAVG, setreturnAVG] = useState<number>(0)
    const [totalHolding, setTotalHolding] = useState<number>(0);
    const [totalInvestment, setTotalInvestment] = useState<number>(0);
    const [investmentAVG, setInvestmentAVG] = useState<number>(0);
    const [totalCurrentSize, setTotalCurrentSize] = useState<number>(0);
    const [currentSizeAVG, setCurrentSizeAVG] = useState<number>(0);
    const [totalReturn, setTotalReturn] = useState<number>(0);

    const resetAllStates = () => {
        setreturnAVG(0);
        setTotalHolding(0);
        setTotalInvestment(0);
        setInvestmentAVG(0);
        setTotalCurrentSize(0);
        setCurrentSizeAVG(0);
        setTotalReturn(0);
    };

    const AbbreviationArr = [
        {
            name: "UL Upper Lock",
            Abbreviation: "Upper limit for rate fluctuation"
        },
        {
            name: "LL Lower Lock",
            Abbreviation: "Lower limit for rate fluctuation"
        },
        {
            name: "HR High Rate:",
            Abbreviation: "Today's highest rate"
        },
        {
            name: "LR Low Rate",
            Abbreviation: "Today's lowest rate"
        },
        {
            name: "OR Open Rate",
            Abbreviation: "Rate of today's first trade"
        },
        {
            name: "CR Current Rate",
            Abbreviation: "Rate of last trade, also called Market Rate or Close Rate"
        },
    ]

    useEffect(() => {
        const handleResize = () => {
            setScreen(window?.outerWidth);
        };

        handleResize();

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const handleShowMore = () => {
        setItemsToShow(prev => prev + itemsPerPage);
    };

    const handleTableCellClick = (
        index,
        barWidth,
        barLeftGap,
        LowerLimitRange,
        UpperLimitRange,
        currentRateIndicator,
        OpenRateIndicator,
        item
    ) => {
        setProgressBarData({
            index,
            barWidth,
            barLeftGap,
            LowerLimitRange,
            UpperLimitRange,
            currentRateIndicator,
            OpenRateIndicator,
            item
        });
        setProgreesBarFlag(true);
    };

    const fetchProgressBar = (
        index,
        barWidth,
        barLeftGap,
        LowerLimitRange,
        UpperLimitRange,
        currentRateIndicator,
        OpenRateIndicator,
        item,
    ) => {
        return (
            <>
                <div
                    className='d-flex justify-content-between mb-1 position-relative w-100'
                >
                    <small
                        id='progreesBar'
                        data-toggle="tooltip"
                        data-placement="top"
                        title={`LL-${LowerLimitRange}`}
                    >
                        <span
                            className='span_progress_val'>
                            {/* LL- */}
                            LL{' '}
                        </span>
                        {
                            LowerLimitRange
                        }
                    </small>
                    <small
                        id='progreesBar'
                        data-toggle="tooltip"
                        data-placement="top"
                        title={`UL-${UpperLimitRange}`}
                    >
                        <span
                            className='span_progress_val'>
                            {/* UL- */}
                            UL{' '}
                        </span>
                        {
                            UpperLimitRange
                        }
                    </small>
                </div>

                <div
                    style={{
                        background: "linear-gradient(90deg, rgba(252,232,221,1) 0%, rgba(198,252,210,1) 100%)",
                        overflow: "visible"
                    }}
                    className="progress position-relative w-100">
                    <div
                        className="progress-bar position-absolute"
                        role="progressbar"
                        style={{
                            width: `${Math.min(barWidth, 100)}%`,
                            minWidth: "8%",
                            height: "100%",
                            border: "1px solid",
                            borderRadius: "12px",
                            left: `${barLeftGap}%`,
                            backgroundColor: (Number(barLeftGap) + Number(Math.min(barWidth, 100))) > 80 ? "rgb(5, 189, 100)" : barLeftGap <= 5 ? "rgb(222, 79, 69)" :
                                barLeftGap <= 10 ? "rgb(222 79 69 / 59%)" :
                                    barLeftGap <= 300 ? "rgb(23 173 226)" : barLeftGap <= 40 ? "rgb(122, 198, 225)" : "rgb(5, 189, 100)",
                            overflow: "visible"
                        }}
                    >
                        <div className='position-relative w-100'>
                            <div
                                style={{
                                    position: "absolute",
                                    top: "-20px",
                                    left: `${Math.min(currentRateIndicator, 100 - barWidth == 0 ? 5 : barWidth)}%`,
                                    zIndex: 34,
                                }}
                                className='d-flex flex-column align-items-center'>
                                <small
                                    id='progreesBar'
                                    style={{
                                        lineHeight: "normal",
                                        backgroundColor: theme == "dark" ? "#27293da6" : "#ffffff70",
                                        color: theme == "dark" ? "" : "rgba(34, 42, 66, 0.7)"
                                    }}
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title={`CR-${item?.current_price}`}
                                >
                                    <span
                                        className='span_progress_val'
                                    >
                                        {/* CR- */}
                                        CR{' '}
                                    </span>
                                    <small
                                        style={{
                                            color: index == 0 ? "#15c46f" : "#0a4eb8"
                                        }}
                                        className='color_valu'
                                    >
                                        {item?.current_price}
                                    </small>
                                    <FaCaretDown
                                        className='text-primary'
                                        style={{
                                            position: "absolute",
                                            bottom: "-10px",
                                            left: "50%",
                                            transform: "translate(-50%, 0%)",
                                        }}
                                    />
                                </small>
                            </div>
                            <div
                                style={{
                                    position: "absolute",
                                    top: "7px",
                                    left: `${Math.min(OpenRateIndicator, 100 - barWidth == 0 ? 5 : barWidth)}%`,
                                    zIndex: 34,
                                }}
                                className='d-flex flex-column align-items-center'>
                                <small
                                    id='progreesBar'
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title={`OR-${item?.open_price}`}
                                    style={{
                                        lineHeight: "normal",
                                        backgroundColor: theme == "dark" ? "#27293da6" : "#ffffff70",
                                        color: theme == "dark" ? "" : "rgba(34, 42, 66, 0.7)"
                                    }}
                                >
                                    <span
                                        className='span_progress_val'>
                                        {/* OR- */}
                                        OR{' '}
                                    </span>
                                    <small
                                        className='color_valu'
                                    >
                                        {item?.open_price}
                                    </small>
                                    <FaCaretUp
                                        className='text-primary'
                                        style={{
                                            position: "absolute",
                                            top: "-11px",
                                            left: "50%",
                                            transform: "translate(-50%, 0%)",
                                        }}
                                    />

                                </small>
                            </div>
                        </div>
                    </div>

                </div>

                <div className='d-flex justify-content-between mt-1 position-relative w-100'>
                    <small id='progreesBar'
                        data-toggle="tooltip" data-placement="top" title={`LR-${item?.low_price}`}
                    >
                        <span className='span_progress_val'>
                            {/* LR- */}
                            LR{' '}
                        </span>
                        <small className='color_valu' style={{ color: "#f8a774" }} >
                            {item?.low_price}
                        </small>
                    </small>
                    <small id='progreesBar'
                        data-toggle="tooltip" data-placement="top" title={`HR-${item?.high_price}`}
                    >
                        <span className='span_progress_val'>
                            HR{' '}
                        </span>
                        <small className='color_valu' style={{ color: "#12c36d" }} >
                            {item?.high_price}
                        </small>
                    </small>
                </div>
            </>
        )
    }

    const fetchProgressBarCardView = (
        index,
        barWidth,
        barBottomGap,
        LowerLimitRange,
        UpperLimitRange,
        currentRateIndicator,
        OpenRateIndicator,
        item,
    ) => {
        return (
            <div
                style={{ minHeight: "175px", minWidth: "112px" }}
                className='d-flex justify-content-center my-2'>
                <div
                    className='d-flex flex-column justify-content-between mr-1 position-relative' style={{ width: "inherit" }}>
                    <small
                        // style={{ writingMode: "vertical-lr" }}
                        id='progreesBar'
                        data-toggle="tooltip" data-placement="top" title={`UL-${UpperLimitRange}`}
                        className={`smallTagColor-${theme}`} >
                        <span
                            className='span_progress_val'>
                            {/* UL- */}
                            UL{' '}
                        </span>
                        {
                            UpperLimitRange
                        }
                    </small>
                    <small
                        // style={{ writingMode: "vertical-lr" }}
                        id='progreesBar'
                        data-toggle="tooltip" data-placement="top" title={`LL-${LowerLimitRange}`}
                        className={`smallTagColor-${theme}`}>
                        <span
                            className='span_progress_val'>
                            {/* LL- */}
                            LL{' '}
                        </span>
                        {
                            LowerLimitRange
                        }
                    </small>
                </div>

                <div
                    style={{
                        height: "inherit",
                        maxWidth: "9px",
                        overflow: "visible",
                        background: "linear-gradient(90deg, rgba(198,252,210,1) 0%, rgba(252,232,221,1) 100%)"
                    }}
                    className="progress position-relative">
                    <div
                        className="progress-bar position-absolute"
                        role="progressbar"
                        style={{
                            width: "100%",
                            height: `${Math.min(barWidth, 100)}%`,
                            minHeight: "8%",
                            border: "1px solid",
                            borderRadius: "12px",
                            left: "0%",
                            bottom: `${barBottomGap}%`,
                            backgroundColor: barBottomGap <= 5 ? "rgb(222, 79, 69)" :
                                barBottomGap <= 10 ? "rgb(222 79 69 / 59%)" :
                                    barBottomGap <= 30 ? "rgb(23 173 226)" : barBottomGap <= 40 ? "rgb(122, 198, 225)" : "rgb(5, 189, 100)",
                            overflow: "visible"
                        }}
                    >
                        <div style={{ width: "fit-content" }} className='position-relative h-100'>
                            <div
                                style={{
                                    position: "absolute",
                                    right: "-6px",
                                    bottom: `${Math.min(currentRateIndicator, 100 - barWidth == 0 ? 5 : barWidth)}%`,
                                    lineHeight: "15px",
                                    zIndex: 34
                                }}
                                className='d-flex align-items-center'>
                                <small
                                    id='progreesBar'
                                    className={`smallTagColor-${theme}`}
                                    data-toggle="tooltip" data-placement="top" title={`OR-${item?.open_price}`}
                                // style={{ writingMode: "vertical-lr" }}
                                >
                                    <span
                                        style={{ marginRight: "2px" }}
                                        className='span_progress_val'>
                                        {/* OR- */}
                                        OR{' '}
                                    </span>
                                    <small
                                        className='color_valu'
                                    >
                                        {item?.open_price}
                                    </small>
                                </small>
                                <FaCaretDown
                                    className='text-primary'
                                    style={{
                                        transform: "rotate(270deg)"
                                    }}
                                />
                            </div>
                            <div
                                style={{
                                    position: "absolute",
                                    bottom: `${Math.min(OpenRateIndicator, 100 - barWidth == 0 ? 5 : barWidth)}%`,
                                    left: "0px",
                                    lineHeight: "15px",
                                    zIndex: 34
                                }}
                                className='d-flex align-items-center'>
                                <FaCaretUp
                                    className='text-primary'
                                    style={{
                                        transform: "rotate(270deg)"
                                    }}
                                />
                                <small
                                    id='progreesBar'
                                    className={`smallTagColor-${theme}`}
                                    data-toggle="tooltip" data-placement="top" title={`CR-${item?.current_price}`}
                                // style={{ writingMode: "vertical-lr" }}
                                >
                                    <span
                                        style={{ marginRight: "2px" }}
                                        className='span_progress_val'>
                                        {/* CR- */}
                                        CR{' '}
                                    </span>
                                    <small
                                        style={{
                                            color: index == 0 ? "#15c46f" : "#f8a774"
                                        }}
                                        className='color_valu'
                                    >
                                        {item?.current_price}
                                    </small>
                                </small>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='d-flex flex-column justify-content-between ml-1 position-relative' style={{ width: "inherit" }}>
                    <small
                        // style={{ writingMode: "vertical-lr" }}
                        id='progreesBar'
                        data-toggle="tooltip" data-placement="top" title={`HR-${item?.high_price}`}
                        className={`smallTagColor-${theme}`}>
                        <span
                            className='span_progress_val'>
                            HR-
                        </span>
                        <small
                            className='color_valu'
                            style={{ color: "#12c36d" }} >
                            {item?.high_price}
                        </small>
                    </small>
                    <small
                        // style={{ writingMode: "vertical-lr" }}
                        id='progreesBar'
                        data-toggle="tooltip" data-placement="top" title={`LR-${item?.low_price}`}
                        className={`smallTagColor-${theme}`}>
                        <span
                            className='span_progress_val'>
                            LR-
                        </span>
                        <small
                            className='color_valu'
                            style={{ color: "#f8a774" }}>
                            {item?.low_price}
                        </small>
                    </small>
                </div>
            </div>
        )
    }

    const getImageSrc = (symbol: string) => {
        try {
            return require(`../../assets/psxLogos/${symbol}.png`).default;
        } catch (e) {
            return require(`../../assets/psxLogos/0.png`).default;
        }
    };


    // let totalHolding: any = 0;
    // let totalInvestment: any = 0;
    // let investmentAVG: any = 0;
    // let totalCurrentSize: any = 0;
    // let currentSizeAVG: any = 0;
    // let totalReturn: any = 0;
    // let returnAVG: any = 0;


    const getAllPSXData = async (isIntervalCall = false) => {
        const email: string = sessionStorage.getItem("email") || "";
        const amcCode: string = sessionStorage.getItem("amc_code") || "";
        // console.log("+++", isIntervalCall)
        if (!isIntervalCall) {
            setLoading(true)
        }
        try {
            const response = await fetch(`${Config.baseUrl}/dashboard/portfolio/stocks/all`);

            if (response.ok) {
                const jsonData = await response.json();

                const fundRes = await getFundByAmc(email, amcCode, "");

                if (fundRes.status === 200 && fundRes.data.status === 200) {

                    // ------- in this object has also fundcode and fundname object  -----------    
                    const StockMarketNew = fundRes.data.data?.filter(({ stock_market }) => stock_market)
                        .map((item) => {
                            let JsonForm = JSON.parse(item?.stock_market) || []
                            return JsonForm?.map((ele) => {
                                return {
                                    ...ele,
                                    fund_name: item?.fund_name,
                                    fund_code: item?.symbol_code
                                }
                            })
                        }) || [];
                    const filteredStockMarket = StockMarketNew?.filter((item) => item?.length > 0)
                    const filteredWatchData = jsonData.data?.filter(item => !item?.symbol?.includes("-"))

                    const temp11 = filteredStockMarket?.flat(1)
                        ?.map(item => {
                            const getInfoWatch = filteredWatchData?.find(item1 => item1?.symbol === item?.code);
                            return getInfoWatch && {
                                ...item,
                                holding: item?.total_units ? item.total_units : "",
                                total_amount: item ? item?.amount : "",
                                avg_cost_per_unit: item ? item?.average_cost_per_unit : "",
                                bidPrice: getInfoWatch?.bidPrice || 0,
                                bidVol: getInfoWatch?.bidVol || 0,
                                change: getInfoWatch?.change || 0,
                                change_percent: getInfoWatch?.change_percent || "",
                                createdAt: getInfoWatch?.createdAt || '',
                                current_price: getInfoWatch?.current_price || 0,
                                high_price: getInfoWatch?.high_price || 0,
                                ldcp: getInfoWatch?.ldcp || 0,
                                listed_in: getInfoWatch?.listed_in || '',
                                low_price: getInfoWatch?.low_price || 0,
                                open_price: getInfoWatch?.open_price || 0,
                                market: getInfoWatch?.market || '',
                                name: getInfoWatch?.name || '',
                                offerVol: getInfoWatch?.offerVol || 0,
                                offerPrice: getInfoWatch?.offerPrice || 0,
                                sector: getInfoWatch?.sector || '',
                                security_type: getInfoWatch?.security_type || '',
                                symbol: item?.code || '',
                                updatedAt: getInfoWatch?.updatedAt || '',
                                volume: getInfoWatch?.volume || 0,
                                id: getInfoWatch?.id || ''
                            };
                        }) || [];

                    let checkFund: String = ""
                    const mainSelectedFund = sessionStorage?.getItem("mainSelectedFund") || ""
                    if (mainSelectedFund) {
                        let parsedData = JSON.parse(mainSelectedFund)?.fund_name;
                        checkFund = selectedFund || parsedData || "";
                    }

                    const filterOnSelectedFund = temp11?.filter((item) => {
                        const hasHolding = item?.holding && item?.holding > 0;
                        const fundMatches = checkFund ? checkFund === item?.fund_name : true;
                        return hasHolding && fundMatches;
                    })

                    filterOnSelectedFund?.map((item) => {
                        const currentSize: any = (Number(item?.holding) * Number(item?.current_price))?.toFixed(2) || 0
                        const ReturnValu: any = (Number(currentSize) - Number(item?.total_amount))?.toFixed(2)
                        const ReturnValuPercentage: any = ((Number(ReturnValu) / Number(item?.total_amount)) * 100)?.toFixed(2)
                        setTotalHolding(prev => prev + Number(item?.holding || 0));
                        setTotalInvestment(prev => prev + Number(item?.total_amount || 0));
                        setTotalCurrentSize(prev => prev + Number(currentSize || 0));
                        setInvestmentAVG(prev => prev + Number(item?.avg_cost_per_unit || 0));
                        setTotalReturn(prev => prev + Number(ReturnValu));
                        setCurrentSizeAVG(prev => prev + Number(item?.current_price));
                        setreturnAVG(prev => prev + Number(ReturnValuPercentage || 0))
                    })

                    setPsxList(filterOnSelectedFund);
                    setAllData(filterOnSelectedFund);
                }
                setLoading(false)
            }
        } catch (error) {
            setLoading(false)
            console.error("Error fetching data:", error);
        }
    }

    useEffect(() => {
        const fetchStockData = () => {
            getAllPSXData(true);
        };

        getAllPSXData();

        const intervalId = setInterval(fetchStockData, 180000);

        return () => clearInterval(intervalId);
    }, [selectedFund])

    useEffect(() => {
        resetAllStates()
    }, [selectedFund])

    return (
        <div className="content">
            <Modal
                dialogClassName="modal90w"
                centered={true}
                show={progreesBarFlag}
                size="lg"
                backdrop={true}
                onHide={() => {
                    setProgreesBarFlag(false);
                }}
            >
                <div className={`modal-header p-3 `}>
                    <button
                        aria-hidden={true}
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => {
                            setProgreesBarFlag(false);
                        }}
                    >
                        <i className="tim-icons icon-simple-remove text-white" />
                    </button>
                    <h6 className="title title-up">
                        OGCL Rate Fluctuation
                    </h6>
                </div>
                <div className="modal-body">
                    <div
                        style={{
                            minHeight: changeView == "Horizontal" ? "" : "220px"
                        }}
                        className={changeView == "Horizontal" ? "px-2" : 'd-flex justify-content-start'}>
                        {changeView == "Horizontal" ?
                            fetchProgressBar(
                                progressBarData?.index,
                                progressBarData?.barWidth,
                                progressBarData?.barLeftGap,
                                progressBarData?.LowerLimitRange,
                                progressBarData?.UpperLimitRange,
                                progressBarData?.currentRateIndicator,
                                progressBarData?.OpenRateIndicator,
                                progressBarData?.item,
                            )
                            :
                            fetchProgressBarCardView(
                                progressBarData?.index,
                                progressBarData?.barWidth,
                                progressBarData?.barLeftGap,
                                progressBarData?.LowerLimitRange,
                                progressBarData?.UpperLimitRange,
                                progressBarData?.currentRateIndicator,
                                progressBarData?.OpenRateIndicator,
                                progressBarData?.item,
                            )
                        }
                    </div>

                    <div className="d-flex flex-wrap mt-3">
                        <div className={`flex-fill p-2 ${screen <= 500 ? 'w-50' : ''}`}>
                            <div style={{ lineHeight: 'normal' }} className="d-flex flex-column">
                                <small style={{ fontSize: '14px' }}>High Rate</small>
                                <div className="text-primary table_heading_large">
                                    {progressBarData?.item?.high_price || 0}
                                </div>
                            </div>
                        </div>

                        <div className={`flex-fill p-2 ${screen <= 500 ? 'w-50' : ''}`}>
                            <div style={{ lineHeight: 'normal' }} className="d-flex flex-column">
                                <small style={{ fontSize: '14px' }}>Low Rate</small>
                                <div className="text-primary table_heading_large">
                                    {progressBarData?.item?.low_price || 0}
                                </div>
                            </div>
                        </div>

                        <div className={`flex-fill p-2 ${screen <= 500 ? 'w-50' : ''}`}>
                            <div style={{ lineHeight: 'normal' }} className="d-flex flex-column">
                                <small style={{ fontSize: '14px' }}>Current Rate</small>
                                <div className="text-primary table_heading_large">
                                    {progressBarData?.item?.current_price || 0}
                                </div>
                            </div>
                        </div>

                        <div className={`flex-fill p-2 ${screen <= 500 ? 'w-50' : ''}`}>
                            <div style={{ lineHeight: 'normal' }} className="d-flex flex-column">
                                <small style={{ fontSize: '14px' }}>Open Rate</small>
                                <div className="text-primary table_heading_large">
                                    {progressBarData?.item?.open_price || 0}
                                </div>
                            </div>
                        </div>

                        <div className={`flex-fill p-2 ${screen <= 500 ? 'w-50' : ''}`}>
                            <div style={{ lineHeight: 'normal' }} className="d-flex flex-column">
                                <small style={{ fontSize: '14px' }}>Lower Limit</small>
                                <div className="text-primary table_heading_large">
                                    {progressBarData?.LowerLimitRange || 0}
                                </div>
                            </div>
                        </div>

                        <div className={`flex-fill p-2 ${screen <= 500 ? 'w-50' : ''}`}>
                            <div style={{ lineHeight: 'normal' }} className="d-flex flex-column">
                                <small style={{ fontSize: '14px' }}>Upper Limit</small>
                                <div className="text-primary table_heading_large">
                                    {progressBarData?.UpperLimitRange || 0}
                                </div>
                            </div>
                        </div>

                        <div className={`flex-fill p-2 ${screen <= 500 ? 'w-50' : ''}`}>
                            <div style={{ lineHeight: 'normal' }} className="d-flex flex-column">
                                <small style={{ fontSize: '14px' }}>Volume</small>
                                <div className="text-primary table_heading_large">
                                    {numberWithCommas(progressBarData?.item?.volume || 0)}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <div className="table-responsive mt-2">
                        <table
                            className="table mt-0">
                            <tbody>
                                <tr>
                                    <td>
                                        <div
                                            style={{
                                                lineHeight: "normal"
                                            }}
                                            className='d-flex flex-column'>
                                            <small
                                                style={{
                                                    fontSize: "14px"
                                                }}
                                            >
                                                High Rate
                                            </small>
                                            <div className='text-primary table_heading_large'>
                                                {progressBarData?.item?.high_price || 0}
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div
                                            style={{
                                                lineHeight: "normal"
                                            }}
                                            className='d-flex flex-column'>
                                            <small
                                                style={{
                                                    fontSize: "14px"
                                                }}
                                            >
                                                Low Rate
                                            </small>
                                            <div className='text-primary table_heading_large'>
                                                {progressBarData?.item?.low_price || 0}
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div
                                            style={{
                                                lineHeight: "normal"
                                            }}
                                            className='d-flex flex-column'>
                                            <small
                                                style={{
                                                    fontSize: "14px"
                                                }}
                                            >
                                                Current Rate
                                            </small>
                                            <div className='text-primary table_heading_large'>
                                                {progressBarData?.item?.current_price || 0}
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div
                                            style={{
                                                lineHeight: "normal"
                                            }}
                                            className='d-flex flex-column'>
                                            <small
                                                style={{
                                                    fontSize: "14px"
                                                }}
                                            >
                                                Open Rate
                                            </small>
                                            <div className='text-primary table_heading_large'>
                                                {progressBarData?.item?.open_price || 0}
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div
                                            style={{
                                                lineHeight: "normal"
                                            }}
                                            className='d-flex flex-column'>
                                            <small
                                                style={{
                                                    fontSize: "14px"
                                                }}
                                            >
                                                Lower Limit
                                            </small>
                                            <div className='text-primary table_heading_large'>
                                                {progressBarData?.LowerLimitRange || 0}
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div
                                            style={{
                                                lineHeight: "normal"
                                            }}
                                            className='d-flex flex-column'>
                                            <small
                                                style={{
                                                    fontSize: "14px"
                                                }}
                                            >
                                                Upper Limit
                                            </small>
                                            <div className='text-primary table_heading_large'>
                                                {progressBarData?.UpperLimitRange || 0}
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div
                                            style={{
                                                lineHeight: "normal"
                                            }}
                                            className='d-flex flex-column'>
                                            <small
                                                style={{
                                                    fontSize: "14px"
                                                }}
                                            >
                                                Volume
                                            </small>
                                            <div className='text-primary table_heading_large'>
                                                {numberWithCommas(progressBarData?.item?.volume || 0)}
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div> */}
                </div>
            </Modal>
            <Row>
                <Col md="12">
                    <Container fluid>
                        <div className="card ">
                            <div
                                style={{
                                    minHeight: "100vh"
                                }}
                                className="card-body">
                                <Row
                                    style={{
                                        rowGap: screen <= 1199 ? "13px" : ""
                                    }}
                                    className='d-flex justify-content-between align-items-center'>
                                    <Col
                                        xl="6"
                                        lg="6"
                                        md="6"
                                        className={`d-flex ${screen <= 500 ? "flex-column justify-content-center align-items-center" : "justify-content-start"} align-items-center`}
                                    >
                                        <h5
                                            onClick={() => history.push("/admin/Money_market")}
                                            className='text-primary mb-0'>
                                            Portfolio
                                        </h5>
                                        <div
                                            style={{
                                                maxWidth: "210px"
                                            }}
                                            className={`input-group ml-${screen <= 500 ? "0" : "5"} mb-0 position-relative `}>
                                            <input
                                                style={{
                                                    borderRadius: "50px",
                                                    textAlign: "left",
                                                    padding: "4px 18px"
                                                }}
                                                type={"text"}
                                                value={searchCompany}
                                                placeholder='Search'
                                                className="form-control text-center"
                                                aria-label="Username"
                                                aria-describedby="basic-addon1"
                                                onChange={(e) => {
                                                    setSearchCompany(e?.target?.value);
                                                    if (e?.target?.value) {
                                                        let temp = allData?.filter((item) => {
                                                            return (
                                                                item?.name?.toLowerCase()?.includes(e?.target?.value?.toLowerCase()) ||
                                                                item?.symbol?.toLowerCase()?.includes(e?.target?.value?.toLowerCase()) ||
                                                                item?.fund_name?.toLowerCase()?.includes(e?.target?.value?.toLowerCase()) ||
                                                                item?.fund_code?.toLowerCase()?.includes(e?.target?.value?.toLowerCase())
                                                            );
                                                        });
                                                        setPsxList(temp);
                                                    } else {
                                                        setPsxList(allData);
                                                    }
                                                }}
                                            />
                                        </div>
                                    </Col>
                                    <Col
                                        xl="6"
                                        lg="6"
                                        md="12"
                                        className={`d-flex ${screen <= 500 ? "justify-content-center flex-column" : screen <= 991 ? "justify-content-between" : "justify-content-end"} align-items-center`}>
                                        {/* <div className={`${screen <= 500 ? "mr-0 mb-2" : "mr-5"} d-flex flex-wrap justify-content-center align-items-center`}>
                                            <Button className='onHover-btn-effect' size="sm" color="primary" >
                                                Long Term
                                            </Button>
                                            <Button className='onHover-btn-effect' size="sm" outline color="primary" >
                                                Kids Inv
                                            </Button>
                                            <AiOutlinePlusCircle
                                                className='ml-2'
                                                style={{
                                                    cursor: "pointer",
                                                    height: "30px",
                                                    width: "30px"
                                                }}
                                            />
                                        </div> */}
                                        <div className='mr-1'>
                                            <VscSplitVertical
                                                data-toggle="tooltip"
                                                data-placement="top"
                                                title={"Table View"}
                                                onClick={() => setChangeView("Horizontal")}
                                                className={`${changeView == "Horizontal" ? "text-info" : ""}`}
                                                style={{
                                                    cursor: "pointer",
                                                    height: "26px",
                                                    width: "26px",

                                                }}
                                            />
                                            <VscSplitVertical
                                                data-toggle="tooltip"
                                                data-placement="top"
                                                title={"Card View"}
                                                className={`${changeView == "Vertical" ? "text-info" : ""}`}
                                                onClick={() => setChangeView("Vertical")}
                                                style={{
                                                    cursor: "pointer",
                                                    height: "26px",
                                                    width: "26px",
                                                    marginBottom: "5px",
                                                    marginLeft: "2px",
                                                    transform: "rotate(90deg)"
                                                }}
                                            />
                                        </div>
                                    </Col>
                                </Row>

                                {!loading ?
                                    psxList?.length > 0 ?
                                        (
                                            changeView == "Horizontal" ?
                                                <>
                                                    <div className="table-responsive">
                                                        <table
                                                            style={{
                                                                minWidth: "1200px"
                                                            }}
                                                            className="table mt-3">
                                                            <thead>
                                                                <tr
                                                                    style={{
                                                                        background: "black"
                                                                    }}
                                                                >
                                                                    <th></th>
                                                                    <th></th>
                                                                    <th></th>
                                                                    <th></th>
                                                                    <th className='text-center'>
                                                                        <div
                                                                            style={{
                                                                                lineHeight: "normal"
                                                                            }}
                                                                            className='d-flex flex-column align-items-center'>
                                                                            <small
                                                                                style={{
                                                                                    color: "rgba(255, 255, 255, 0.7)"
                                                                                }}
                                                                            >
                                                                                Total Shareholding
                                                                            </small>
                                                                            <p
                                                                                style={{
                                                                                    fontWeight: 600
                                                                                }}
                                                                                className='mb-0 table_heading_large text-primary'>
                                                                                {numberWithCommas(Number(totalHolding)?.toFixed(0) || 0)}
                                                                            </p>
                                                                            <small
                                                                                className='text-info small_heading'
                                                                            >
                                                                                shares
                                                                            </small>
                                                                        </div>
                                                                    </th>
                                                                    <th className='text-center'>
                                                                        <div
                                                                            style={{
                                                                                lineHeight: "normal"
                                                                            }}
                                                                            className='d-flex flex-column align-items-center'>
                                                                            <small
                                                                                style={{
                                                                                    color: "rgba(255, 255, 255, 0.7)"
                                                                                }}
                                                                            >
                                                                                Total Investment
                                                                            </small>
                                                                            <p
                                                                                style={{
                                                                                    fontWeight: 600
                                                                                }}
                                                                                className='mb-0 table_heading_large text-primary'>
                                                                                {numberWithCommas(Number(totalInvestment)?.toFixed(2) || 0)}
                                                                            </p>
                                                                            <small
                                                                                className='text-info small_heading'
                                                                            >
                                                                                {numberWithCommas((Number(investmentAVG) / psxList?.length)?.toFixed(2) || 0)}
                                                                            </small>
                                                                        </div>
                                                                    </th>
                                                                    <th className='text-center'>
                                                                        <div
                                                                            style={{
                                                                                lineHeight: "normal"
                                                                            }}
                                                                            className='d-flex flex-column align-items-center'>
                                                                            <small
                                                                                style={{
                                                                                    color: "rgba(255, 255, 255, 0.7)"
                                                                                }}
                                                                            >
                                                                                Current Size
                                                                            </small>
                                                                            <p
                                                                                style={{
                                                                                    fontWeight: 600
                                                                                }}
                                                                                className='mb-0 table_heading_large text-primary'>
                                                                                {numberWithCommas(Number(totalCurrentSize)?.toFixed(2) || 0)}
                                                                            </p>
                                                                            <small
                                                                                className='text-info small_heading'
                                                                            >
                                                                                {numberWithCommas((Number(currentSizeAVG) / psxList?.length)?.toFixed(2) || 0)}
                                                                            </small>
                                                                        </div>
                                                                    </th>
                                                                    <th className='text-center'>
                                                                        <div
                                                                            style={{
                                                                                lineHeight: "normal"
                                                                            }}
                                                                            className='d-flex flex-column align-items-center'>
                                                                            <small
                                                                                style={{
                                                                                    color: "rgba(255, 255, 255, 0.7)"
                                                                                }}
                                                                            >
                                                                                Total Return
                                                                            </small>
                                                                            <p
                                                                                style={{
                                                                                    fontWeight: 600,
                                                                                    color: Number(totalReturn) > 0 ?
                                                                                        "#05bd64" :
                                                                                        Number(totalReturn) < 0 ?
                                                                                            "#de4f45" :
                                                                                            "#7ac6e1"
                                                                                }}
                                                                                className='mb-0 table_heading_large '>
                                                                                {numberWithCommas(Number(totalReturn)?.toFixed(2) || 0)}
                                                                            </p>
                                                                            <small
                                                                                style={{
                                                                                    color: +((Number(totalReturn) / Number(totalInvestment)) * 100)?.toFixed(2) > 0 ?
                                                                                        "#05bd64" :
                                                                                        +((Number(totalReturn) / Number(totalInvestment)) * 100)?.toFixed(2) < 0 ?
                                                                                            "#de4f45" :
                                                                                            "#7ac6e1"
                                                                                }}
                                                                                className='small_heading'
                                                                            >
                                                                                {numberWithCommas(((Number(totalReturn) / Number(totalInvestment)) * 100)?.toFixed(2) || 0)}
                                                                                %{" "}
                                                                                {
                                                                                    +((Number(totalReturn) / Number(totalInvestment)) * 100)?.toFixed(2) > 0 ? "Profit" : "Loss"
                                                                                }
                                                                            </small>
                                                                        </div>
                                                                    </th>
                                                                    <th></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {psxList?.slice(0, itemsToShow)?.map((item, index) => {
                                                                    const UpperLimit: any = item?.ldcp !== 0 ? ((item?.ldcp * 0.1) < 1 ? (item?.ldcp + 1) : (item?.ldcp * 1.1)) : 0
                                                                    const LowerLimit: any = item?.ldcp !== 0 ? ((item?.ldcp * 0.1) < 1 ? (item?.ldcp - 1) : (item?.ldcp * 0.9)) : 0
                                                                    const UpperLimitRange: any =
                                                                        item?.ldcp <= 10 ?
                                                                            (item?.ldcp + 1)?.toFixed(2) :
                                                                            (UpperLimit)?.toFixed(2)

                                                                    const LowerLimitRange: any =
                                                                        item?.ldcp <= 10 ?
                                                                            (item?.ldcp - 1)?.toFixed(2) :
                                                                            (LowerLimit)?.toFixed(2)

                                                                    const barWidth: any =
                                                                        ((item?.high_price - item?.low_price) / (Number(UpperLimitRange) - Number(LowerLimitRange))) * 100

                                                                    const leftPercentBar: any =
                                                                        (((item?.low_price - LowerLimitRange) / (UpperLimitRange - LowerLimitRange)) * 100)?.toString()?.replace("-", "")

                                                                    const barLeftGap: any = `${Math.min(barWidth, 100) == 100 ? 0 : Math.min(leftPercentBar, 100 - barWidth == 0 ? 8 : barWidth)}`
                                                                    const currentSize: any = (Number(item?.holding) * Number(item?.current_price))?.toFixed(2) || 0
                                                                    const ReturnValu: any = (Number(currentSize) - Number(item?.total_amount))?.toFixed(2)
                                                                    const ReturnValuPercentage: any = ((Number(ReturnValu) / Number(item?.total_amount)) * 100)?.toFixed(2)

                                                                    const currentRateIndicator: any = ((item?.current_price - item?.low_price) / (item?.high_price - item?.low_price) * barWidth)
                                                                    const OpenRateIndicator: any = ((item?.open_price - item?.low_price) / (item?.high_price - item?.low_price) * barWidth)

                                                                    // totalHolding += Number(item?.holding || 0)
                                                                    // totalInvestment += Number(item?.total_amount || 0)
                                                                    // totalCurrentSize += Number(currentSize || 0)
                                                                    // investmentAVG += Number(item?.avg_cost_per_unit || 0)
                                                                    // totalReturn += Number(ReturnValu)
                                                                    // currentSizeAVG += Number(item?.current_price)
                                                                    // returnAVG += Number(ReturnValuPercentage)
                                                                    return (
                                                                        <tr >
                                                                            <td
                                                                                style={{
                                                                                    width: "120px",
                                                                                    maxWidth: "180px"
                                                                                }}
                                                                                className='border-y'>
                                                                                <div
                                                                                    style={{
                                                                                        lineHeight: "normal"
                                                                                    }}
                                                                                    className='d-flex align-items-center w-75'
                                                                                >
                                                                                    <img
                                                                                        className='mr-2'
                                                                                        src={getImageSrc(item?.symbol)}
                                                                                        width={50}
                                                                                        height={50}
                                                                                        style={{
                                                                                            objectFit: "contain",
                                                                                            objectPosition: "center"
                                                                                        }}
                                                                                    />
                                                                                    <div
                                                                                        style={{
                                                                                            width: "inherit"
                                                                                        }}
                                                                                        className='d-flex flex-column'>
                                                                                        <small
                                                                                            style={{
                                                                                                opacity: "0.4"
                                                                                            }}>
                                                                                            Security
                                                                                        </small>
                                                                                        <p
                                                                                            style={{
                                                                                                fontWeight: 600
                                                                                            }}
                                                                                            data-toggle="tooltip"
                                                                                            data-placement="top"
                                                                                            title={item?.symbol}
                                                                                            className='mb-0 text-primary text-truncate table_heading_large'>
                                                                                            {item?.symbol}
                                                                                        </p>
                                                                                        <small
                                                                                            id='progreesBar'
                                                                                            data-toggle="tooltip"
                                                                                            data-placement="top"
                                                                                            title={item?.name}
                                                                                            className='text-info small_heading text-truncate'>
                                                                                            {item?.name}
                                                                                        </small>
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                            <td
                                                                                className='border-y'>
                                                                                <div
                                                                                    style={{
                                                                                        lineHeight: "normal"
                                                                                    }}
                                                                                    className='d-flex flex-column align-items-center'
                                                                                >
                                                                                    <small
                                                                                        style={{
                                                                                            opacity: "0.4"
                                                                                        }}>
                                                                                        Rate
                                                                                    </small>
                                                                                    <p
                                                                                        style={{
                                                                                            fontWeight: 600
                                                                                        }}
                                                                                        className='mb-0 text-primary table_heading_large'>
                                                                                        <small
                                                                                            className='xSmall'
                                                                                        >
                                                                                            Rs.
                                                                                        </small>
                                                                                        {
                                                                                            numberWithCommas(item?.current_price?.toString()?.includes(".") ?
                                                                                                item?.current_price?.toString()?.split(".")[0] :
                                                                                                item?.current_price || 0)
                                                                                        }
                                                                                        <small className='xSmall'>
                                                                                            .{
                                                                                                item?.current_price?.toString()?.includes(".") ?
                                                                                                    item?.current_price?.toString()?.split(".")[1] :
                                                                                                    "00"
                                                                                            }
                                                                                        </small>
                                                                                    </p>
                                                                                    <small
                                                                                        className='text-info small_heading'
                                                                                    >
                                                                                        Per Share
                                                                                    </small>
                                                                                </div>
                                                                            </td>
                                                                            <td
                                                                                onClick={() => handleTableCellClick(
                                                                                    index,
                                                                                    barWidth,
                                                                                    barLeftGap,
                                                                                    LowerLimitRange,
                                                                                    UpperLimitRange,
                                                                                    currentRateIndicator,
                                                                                    OpenRateIndicator,
                                                                                    item,
                                                                                )}
                                                                                style={{
                                                                                    minWidth: "160px",
                                                                                    cursor: "pointer"
                                                                                }}
                                                                                className='border-y '>
                                                                                {fetchProgressBar(
                                                                                    index,
                                                                                    barWidth,
                                                                                    barLeftGap,
                                                                                    LowerLimitRange,
                                                                                    UpperLimitRange,
                                                                                    currentRateIndicator,
                                                                                    OpenRateIndicator,
                                                                                    item,
                                                                                )}

                                                                            </td>
                                                                            <td
                                                                                className='border-y'>
                                                                                <div
                                                                                    style={{
                                                                                        lineHeight: "normal"
                                                                                    }}
                                                                                    className='d-flex flex-column align-items-center'
                                                                                >
                                                                                    <small
                                                                                        style={{
                                                                                            opacity: "0.4"
                                                                                        }}>
                                                                                        Change
                                                                                    </small>
                                                                                    <p
                                                                                        style={{
                                                                                            fontWeight: 600,
                                                                                            color: item?.change > 0 ?
                                                                                                "#05bd64" :
                                                                                                item?.change < 0 ?
                                                                                                    "#de4f45" :
                                                                                                    "#7ac6e1"
                                                                                        }}
                                                                                        className='mb-0 table_heading_large'>
                                                                                        <small
                                                                                            className='xSmall'
                                                                                        >
                                                                                            Rs.
                                                                                        </small>
                                                                                        {
                                                                                            item?.change?.toString()?.split(".")[0] || "0"}
                                                                                        <small className='xSmall'>
                                                                                            .{item?.change?.toString()?.split(".")[1] || "00"}
                                                                                        </small>
                                                                                    </p>
                                                                                    <small
                                                                                        style={{
                                                                                            color: Number(item?.change_percent?.replace("%", "")) > 0 ?
                                                                                                "#05bd64" :
                                                                                                Number(item?.change_percent?.replace("%", "")) < 0 ?
                                                                                                    "#de4f45" :
                                                                                                    "#7ac6e1"
                                                                                        }}
                                                                                        className='small_heading'
                                                                                    >
                                                                                        {item?.change_percent}
                                                                                    </small>
                                                                                </div>
                                                                            </td>

                                                                            <td
                                                                                style={{
                                                                                    maxWidth: "120px"
                                                                                }}
                                                                                className='border-y'>
                                                                                <div
                                                                                    style={{
                                                                                        lineHeight: "normal"
                                                                                    }}
                                                                                    className='d-flex flex-column align-items-center'>
                                                                                    <small
                                                                                        style={{
                                                                                            opacity: "0.4"
                                                                                        }}
                                                                                    >
                                                                                        Holding
                                                                                    </small>
                                                                                    <p
                                                                                        style={{
                                                                                            fontWeight: 600
                                                                                        }}
                                                                                        className='mb-0 table_heading_large text-primary'>
                                                                                        {(numberWithCommas(Number(item?.holding)?.toFixed(0)))}
                                                                                    </p>
                                                                                    <small
                                                                                        className='text-info small_heading'
                                                                                    >
                                                                                        Shares
                                                                                    </small>
                                                                                </div>
                                                                            </td>

                                                                            <td
                                                                                style={{
                                                                                    maxWidth: "120px"
                                                                                }}
                                                                                className='border-y'>
                                                                                <div
                                                                                    style={{
                                                                                        lineHeight: "normal"
                                                                                    }}
                                                                                    className='d-flex flex-column align-items-center'
                                                                                >
                                                                                    <small
                                                                                        style={{
                                                                                            opacity: "0.4"
                                                                                        }}>
                                                                                        Investment
                                                                                    </small>
                                                                                    <p
                                                                                        style={{
                                                                                            fontWeight: 600
                                                                                        }}
                                                                                        className='mb-0 text-primary table_heading_large'>
                                                                                        <small
                                                                                            className='xSmall'
                                                                                        >
                                                                                            Rs.
                                                                                        </small>
                                                                                        {
                                                                                            numberWithCommas(item?.total_amount?.toString()?.includes(".") ?
                                                                                                item?.total_amount?.toString()?.split(".")[0] :
                                                                                                item?.total_amount || 0)
                                                                                        }
                                                                                        <small className='xSmall'>
                                                                                            .{
                                                                                                item?.total_amount?.toString()?.includes(".") ?
                                                                                                    item?.total_amount?.toString()?.split(".")[1] :
                                                                                                    "00"
                                                                                            }
                                                                                        </small>
                                                                                    </p>
                                                                                    <small
                                                                                        className='text-info small_heading'
                                                                                    >
                                                                                        @ {item?.avg_cost_per_unit || 0}
                                                                                    </small>
                                                                                </div>

                                                                            </td>

                                                                            <td
                                                                                style={{
                                                                                    maxWidth: "120px"
                                                                                }}
                                                                                className='border-y'>
                                                                                <div
                                                                                    style={{
                                                                                        lineHeight: "normal"
                                                                                    }}
                                                                                    className='d-flex flex-column align-items-center'
                                                                                >
                                                                                    <small
                                                                                        style={{
                                                                                            opacity: "0.4"
                                                                                        }}>
                                                                                        Current Size
                                                                                    </small>
                                                                                    <p
                                                                                        style={{
                                                                                            fontWeight: 600
                                                                                        }}
                                                                                        className='mb-0 text-primary table_heading_large'>
                                                                                        <small
                                                                                            className='xSmall'
                                                                                        >
                                                                                            Rs.
                                                                                        </small>
                                                                                        {
                                                                                            numberWithCommas(currentSize?.toString()?.includes(".") ?
                                                                                                currentSize?.toString()?.split(".")[0] :
                                                                                                currentSize || 0)
                                                                                        }
                                                                                        <small className='xSmall'>
                                                                                            .{
                                                                                                currentSize?.toString()?.includes(".") ?
                                                                                                    currentSize?.toString()?.split(".")[1] :
                                                                                                    "00"
                                                                                            }
                                                                                        </small>
                                                                                    </p>
                                                                                    <small
                                                                                        className='text-info small_heading'
                                                                                    >
                                                                                        @ {item?.current_price || 0}
                                                                                    </small>
                                                                                </div>

                                                                            </td>

                                                                            <td
                                                                                style={{
                                                                                    maxWidth: "120px"
                                                                                }}
                                                                                className='border-y'>
                                                                                <div
                                                                                    style={{
                                                                                        lineHeight: "normal"
                                                                                    }}
                                                                                    className='d-flex flex-column align-items-center'
                                                                                >
                                                                                    <small
                                                                                        style={{
                                                                                            opacity: "0.4"
                                                                                        }}>
                                                                                        Return
                                                                                    </small>
                                                                                    <p
                                                                                        style={{
                                                                                            fontWeight: 600,
                                                                                            color: ReturnValu > 0 ?
                                                                                                "#05bd64" :
                                                                                                ReturnValu < 0 ?
                                                                                                    "#de4f45" :
                                                                                                    "#7ac6e1"
                                                                                        }}
                                                                                        className='mb-0 table_heading_large'>
                                                                                        <small
                                                                                            className='xSmall'
                                                                                        >
                                                                                            Rs.
                                                                                        </small>
                                                                                        {
                                                                                            numberWithCommas(ReturnValu?.toString()?.includes(".") ?
                                                                                                ReturnValu?.toString()?.split(".")[0] :
                                                                                                ReturnValu || 0)
                                                                                        }
                                                                                        <small className='xSmall small_heading'>
                                                                                            .{
                                                                                                ReturnValu?.toString()?.includes(".") ?
                                                                                                    ReturnValu?.toString()?.split(".")[1] :
                                                                                                    "00"
                                                                                            }
                                                                                        </small>
                                                                                    </p>
                                                                                    <small
                                                                                        style={{
                                                                                            color: ReturnValuPercentage > 0 ?
                                                                                                "#05bd64" :
                                                                                                ReturnValuPercentage < 0 ?
                                                                                                    "#de4f45" :
                                                                                                    "#7ac6e1"
                                                                                        }}
                                                                                    >
                                                                                        {/* {Math.min(ReturnValuPercentage, 100)} */}
                                                                                        {ReturnValuPercentage}
                                                                                        %{" "}
                                                                                        {+ReturnValuPercentage > 0 ? "Profit" : "Loss"}
                                                                                        {/* {Math.min(ReturnValuPercentage, 100) > 0 ? "Profit" : "Loss"} */}
                                                                                    </small>
                                                                                </div>
                                                                            </td>

                                                                            <td
                                                                                style={{
                                                                                    width: "120px",
                                                                                    maxWidth: "180px"
                                                                                }}
                                                                                className='border-y'>
                                                                                <div
                                                                                    style={{
                                                                                        width: "inherit",
                                                                                        lineHeight: "normal"
                                                                                    }}
                                                                                    className='d-flex flex-column text-center'>
                                                                                    <small
                                                                                        style={{
                                                                                            opacity: "0.4"
                                                                                        }}>
                                                                                        Fund
                                                                                    </small>
                                                                                    <p
                                                                                        style={{
                                                                                            fontWeight: 600
                                                                                        }}
                                                                                        className='mb-0 text-primary table_heading_large'>
                                                                                        {item?.fund_code}
                                                                                    </p>
                                                                                    <small
                                                                                        id='progreesBar'
                                                                                        data-toggle="tooltip"
                                                                                        data-placement="top"
                                                                                        title={item?.fund_name}
                                                                                        className='text-info small_heading text-truncate'>
                                                                                        {item?.fund_name}
                                                                                    </small>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                })}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    {itemsToShow < psxList.length && (
                                                        <div className='d-flex justify-content-center my-2'>
                                                            <Button
                                                                size="md"
                                                                id='hoverNoEffect'
                                                                style={{
                                                                    background: "none"
                                                                }}
                                                                className=' border border-primary'
                                                                onClick={handleShowMore}
                                                            >
                                                                Show More
                                                            </Button>
                                                        </div>
                                                    )}
                                                </>
                                                :
                                                <Col
                                                    className='col-12 mt-3'>
                                                    <div
                                                        className={`border border-info ${screen <= 500 ? "row" : ""}`}
                                                        style={{ padding: "5px 10px", borderRadius: "12px" }}>
                                                        <Row className="text-center">
                                                            <Col
                                                                xl={3} lg={3} md={3} sm={12} xs={12}
                                                                className="my-2 d-flex flex-column align-items-center" style={{ lineHeight: "normal" }}>
                                                                <small
                                                                    style={{
                                                                        color: "rgba(255, 255, 255, 0.7)",
                                                                        textTransform: "uppercase"
                                                                    }}
                                                                >
                                                                    Total Shareholding
                                                                </small>
                                                                <p
                                                                    style={{
                                                                        fontWeight: 600,
                                                                    }}
                                                                    className="mb-0 w-100 table_heading_large text-primary fw-bold">
                                                                    {numberWithCommas(Number(totalHolding)?.toFixed(0) || 0)}
                                                                </p>
                                                                <small className="text-info small_heading">SHARES</small>
                                                            </Col>

                                                            <Col
                                                                xl={3} lg={3} md={3} sm={12} xs={12}
                                                                className="my-2 d-flex flex-column align-items-center" style={{ lineHeight: "normal" }}>
                                                                <small
                                                                    style={{
                                                                        color: "rgba(255, 255, 255, 0.7)",
                                                                        textTransform: "uppercase"
                                                                    }}
                                                                >
                                                                    Total Investment
                                                                </small>
                                                                <p
                                                                    style={{
                                                                        fontWeight: 600,
                                                                    }}
                                                                    className="w-100 mb-0 table_heading_large text-primary fw-bold">
                                                                    {numberWithCommas(Number(totalInvestment)?.toFixed(2) || 0)}
                                                                </p>
                                                                <small className="w-100 text-info small_heading">
                                                                    {numberWithCommas((Number(investmentAVG) / psxList?.length)?.toFixed(2) || 0)}
                                                                </small>
                                                            </Col>

                                                            <Col
                                                                xl={3} lg={3} md={3} sm={12} xs={12}
                                                                className="my-2 d-flex flex-column align-items-center" style={{ lineHeight: "normal" }}>
                                                                <small
                                                                    style={{
                                                                        color: "rgba(255, 255, 255, 0.7)",
                                                                        textTransform: "uppercase"
                                                                    }}
                                                                >
                                                                    Current Size
                                                                </small>
                                                                <p
                                                                    style={{
                                                                        fontWeight: 600,
                                                                    }}
                                                                    className="w-100 mb-0 table_heading_large text-primary fw-bold">
                                                                    {numberWithCommas(Number(totalCurrentSize)?.toFixed(2) || 0)}
                                                                </p>
                                                                <small className="w-100 text-info small_heading">
                                                                    {numberWithCommas((Number(currentSizeAVG) / psxList?.length)?.toFixed(2) || 0)}
                                                                </small>
                                                            </Col>

                                                            <Col
                                                                xl={3} lg={3} md={3} sm={12} xs={12}
                                                                className="my-2 d-flex flex-column align-items-center" style={{ lineHeight: "normal" }}>
                                                                <small
                                                                    style={{
                                                                        color: "rgba(255, 255, 255, 0.7)",
                                                                        textTransform: "uppercase"
                                                                    }}
                                                                >
                                                                    Total Return
                                                                </small>
                                                                <p
                                                                    className="mb-0 w-100 table_heading_large"
                                                                    style={{
                                                                        fontWeight: 600,
                                                                        color:
                                                                            Number(totalReturn) > 0
                                                                                ? "#05bd64"
                                                                                : Number(totalReturn) < 0
                                                                                    ? "#de4f45"
                                                                                    : "#7ac6e1",
                                                                    }}
                                                                >
                                                                    {numberWithCommas(Number(totalReturn)?.toFixed(2) || 0)}
                                                                </p>
                                                                <small
                                                                    className="small_heading w-100"
                                                                    style={{
                                                                        color:
                                                                            +((Number(totalReturn) / Number(totalInvestment)) * 100)?.toFixed(2) > 0
                                                                                ? "#05bd64"
                                                                                : +((Number(totalReturn) / Number(totalInvestment)) * 100)?.toFixed(2) < 0
                                                                                    ? "#de4f45"
                                                                                    : "#7ac6e1",
                                                                    }}
                                                                >
                                                                    {numberWithCommas(((Number(totalReturn) / Number(totalInvestment)) * 100)?.toFixed(2) || 0)}
                                                                    %{" "}
                                                                    {+((Number(totalReturn) / Number(totalInvestment)) * 100)?.toFixed(2) > 0 ? "Profit" : "Loss"}
                                                                </small>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                    <Row className='pt-3'>
                                                        {psxList?.slice(0, itemsToShow)?.map((item, index) => {
                                                            const UpperLimit: any = item?.ldcp !== 0 ? ((item?.ldcp * 0.1) < 1 ? (item?.ldcp + 1) : (item?.ldcp * 1.1)) : 0
                                                            const LowerLimit: any = item?.ldcp !== 0 ? ((item?.ldcp * 0.1) < 1 ? (item?.ldcp - 1) : (item?.ldcp * 0.9)) : 0
                                                            const UpperLimitRange: any =
                                                                item?.ldcp <= 10 ?
                                                                    (item?.ldcp + 1)?.toFixed(2) :
                                                                    (UpperLimit)?.toFixed(2)

                                                            const LowerLimitRange: any =
                                                                item?.ldcp <= 10 ?
                                                                    (item?.ldcp - 1)?.toFixed(2) :
                                                                    (LowerLimit)?.toFixed(2)

                                                            const barWidth: any =
                                                                ((item?.high_price - item?.low_price) / (Number(UpperLimitRange) - Number(LowerLimitRange))) * 100

                                                            // const barWidth: any =
                                                            //     (item?.high_price + item?.low_price) == 0 ? 1 :
                                                            //         ((UpperLimitRange - LowerLimitRange) / (item?.high_price + item?.low_price)) * 100


                                                            const leftPercentBar: any =
                                                                (((item?.low_price - LowerLimitRange) / (UpperLimitRange - LowerLimitRange)) * 100)?.toString()?.replace("-", "")

                                                            const barBottomGap: any = `${Math.min(barWidth, 100) == 100 ? 0 : Math.min(leftPercentBar, 100 - barWidth == 0 ? 8 : barWidth)}`
                                                            const currentSize: any = (Number(item?.holding) * Number(item?.current_price))?.toFixed(2) || 0
                                                            const ReturnValu: any = (Number(currentSize) - Number(item?.total_amount))?.toFixed(2)
                                                            const ReturnValuPercentage: any = ((Number(ReturnValu) / Number(item?.total_amount)) * 100)?.toFixed(2)

                                                            // const leftPercentBar: any =
                                                            //     barWidth == 0 ? 0 :
                                                            //         (((LowerLimitRange - item?.low_price) / barWidth) * 100)?.toString()?.replace("-", "")

                                                            // const currentRateIndicator: any =
                                                            //     item?.current_price < item?.open_price ? (Math.min(leftPercentBar, 100 - barWidth == 0 ? 5 : barWidth) - 2) : ((Math.min(leftPercentBar, 100 - barWidth == 0 ? 5 : barWidth) + Number(barWidth == 0 ? 5 : barWidth)) - 6)

                                                            // const OpenRateIndicator: any =
                                                            //     item?.current_price > item?.open_price ? (Math.min(leftPercentBar, 100 - barWidth == 0 ? 5 : barWidth) - 2) : ((Math.min(leftPercentBar, 100 - barWidth == 0 ? 5 : barWidth) + Number(barWidth == 0 ? 5 : barWidth)) - 6)

                                                            const currentRateIndicator: any = ((item?.current_price - item?.low_price) / (item?.high_price - item?.low_price) * barWidth)
                                                            const OpenRateIndicator: any = ((item?.open_price - item?.low_price) / (item?.high_price - item?.low_price) * barWidth)

                                                            const Investment: any = (Number(item?.holding) * Number(item?.current_price))?.toFixed(2)
                                                            const ReturnVal: any = (Number(Investment) - Number(item?.holding))?.toFixed(2)
                                                            const ReturnPercentage: any = Number(Investment) == 0 ? 0 : ((Number(ReturnVal) / Number(Investment)) * 100)?.toFixed(2)

                                                            const OuterBarPercentage: any = Number(Investment) == 0 ? 0 : ((Number(item?.holding) * Number(item?.bidPrice)) / Number(Investment) + Number(item?.holding)) * 100

                                                            const InnerBarPercentage: any = Number(Investment) == 0 ? 0 : ((Number(item?.holding) * Number(item?.current_price)) / Number(Investment) + Number(item?.holding)) * 100

                                                            // const currentRateIndicator: any = ((item?.low_price + item?.high_price)) == 0 ? 0 : (item?.current_price / (item?.low_price + item?.high_price)) * 100
                                                            // const OpenRateIndicator: any = (item?.low_price + item?.high_price) == 0 ? 0 : (item?.open_price / (item?.low_price + item?.high_price)) * 100
                                                            return (
                                                                <Col lg="4" xl="2" md="4" className={`mb-5 ${screen <= 500 ? "pb-3 border-bottom px-0" : ""}`}>
                                                                    <div
                                                                        style={{
                                                                            rowGap: "10px",
                                                                            borderRadius: "15px",
                                                                            border: "1px solid #1d8cf8",
                                                                            minHeight: "835px"
                                                                        }}
                                                                        className='d-flex flex-column align-items-center text-center py-2 shadow'>
                                                                        <img
                                                                            src={getImageSrc(item?.symbol)}
                                                                            width={50}
                                                                            height={50}
                                                                            style={{
                                                                                objectFit: "contain",
                                                                                objectPosition: "center"
                                                                            }}
                                                                        />
                                                                        <div
                                                                            style={{
                                                                                lineHeight: "normal"
                                                                            }}
                                                                            className='d-flex flex-column w-100'
                                                                        >
                                                                            <p
                                                                                style={{
                                                                                    fontWeight: 600
                                                                                }}
                                                                                className='mb-0 text-primary table_heading_large'>
                                                                                {item?.symbol}
                                                                            </p>
                                                                            <small
                                                                                style={{
                                                                                    whiteSpace: "break-spaces",
                                                                                    minHeight: "17px"
                                                                                }}
                                                                                className='text-info'>
                                                                                {item?.name}
                                                                            </small>
                                                                        </div>
                                                                        <div
                                                                            style={{
                                                                                lineHeight: "normal"
                                                                            }}
                                                                            className='d-flex flex-column align-items-center w-100'>
                                                                            <small
                                                                                style={{
                                                                                    opacity: "0.4"
                                                                                }}
                                                                                className={`smallTagColor-${theme}`}>
                                                                                Rate
                                                                            </small>
                                                                            <p
                                                                                style={{
                                                                                    fontWeight: 600,
                                                                                    whiteSpace: "break-spaces"
                                                                                }}
                                                                                className='mb-0 text-primary table_heading_large'>
                                                                                <small
                                                                                    className='xSmall'
                                                                                >
                                                                                    Rs.
                                                                                </small>
                                                                                {
                                                                                    numberWithCommas(item?.current_price?.toString()?.includes(".") ?
                                                                                        item?.current_price?.toString()?.split(".")[0] :
                                                                                        item?.current_price || 0)
                                                                                }
                                                                                <small className='xSmall'>
                                                                                    .{
                                                                                        item?.current_price?.toString()?.includes(".") ?
                                                                                            item?.current_price?.toString()?.split(".")[1] :
                                                                                            "00"
                                                                                    }
                                                                                </small></p>
                                                                            <small
                                                                                className='text-info'
                                                                            >
                                                                                Per Share
                                                                            </small>
                                                                        </div>

                                                                        <div
                                                                            onClick={() => handleTableCellClick(
                                                                                index,
                                                                                barWidth,
                                                                                barBottomGap,
                                                                                LowerLimitRange,
                                                                                UpperLimitRange,
                                                                                currentRateIndicator,
                                                                                OpenRateIndicator,
                                                                                item,
                                                                            )}
                                                                            style={{
                                                                                columnGap: "18px",
                                                                                // height: "165px"
                                                                            }}
                                                                            className='d-flex align-items-center'>
                                                                            {fetchProgressBarCardView(
                                                                                index,
                                                                                barWidth,
                                                                                barBottomGap,
                                                                                LowerLimitRange,
                                                                                UpperLimitRange,
                                                                                currentRateIndicator,
                                                                                OpenRateIndicator,
                                                                                item,
                                                                            )}


                                                                        </div>

                                                                        <div
                                                                            style={{
                                                                                lineHeight: "normal"
                                                                            }}
                                                                            className='d-flex flex-column align-items-center w-100'>
                                                                            <small
                                                                                style={{
                                                                                    opacity: "0.4"
                                                                                }}
                                                                                className={`smallTagColor-${theme}`}>
                                                                                Change
                                                                            </small>
                                                                            <p
                                                                                style={{
                                                                                    fontWeight: 600,
                                                                                    whiteSpace: "break-spaces",
                                                                                    color: item?.change > 0 ?
                                                                                        "#05bd64" :
                                                                                        item?.change < 0 ?
                                                                                            "#de4f45" :
                                                                                            "#7ac6e1"
                                                                                }}
                                                                                className='mb-0 table_heading_large'>
                                                                                <small
                                                                                    className='xSmall'
                                                                                >
                                                                                    Rs.
                                                                                </small>
                                                                                {item?.change?.toString()?.split(".")[0] || "0"}
                                                                                <small
                                                                                    className='xSmall'
                                                                                >
                                                                                    .{item?.change?.toString()?.split(".")[1] || "00"}
                                                                                </small>
                                                                            </p>
                                                                            <small
                                                                                style={{
                                                                                    color: Number(item?.change_percent?.replace("%", "")) > 0 ?
                                                                                        "#05bd64" :
                                                                                        Number(item?.change_percent?.replace("%", "")) < 0 ?
                                                                                            "#de4f45" :
                                                                                            "#7ac6e1"
                                                                                }}
                                                                            >
                                                                                {item?.change_percent || "0.00%"}
                                                                            </small>
                                                                        </div>

                                                                        <div
                                                                        >
                                                                            <div
                                                                                style={{
                                                                                    lineHeight: "normal"
                                                                                }}
                                                                                className='d-flex flex-column align-items-center'
                                                                            >
                                                                                <small
                                                                                    style={{
                                                                                        opacity: "0.4"
                                                                                    }}
                                                                                    className={`smallTagColor-${theme}`}>
                                                                                    Holding
                                                                                </small>
                                                                                <p
                                                                                    style={{
                                                                                        fontWeight: 600
                                                                                    }}
                                                                                    className='mb-0 table_heading_large text-primary'>
                                                                                    {(numberWithCommas(Number(item?.holding)?.toFixed(0)))}
                                                                                </p>
                                                                                <small
                                                                                    className='text-info'
                                                                                >
                                                                                    Shares
                                                                                </small>
                                                                            </div>
                                                                        </div>

                                                                        <div
                                                                        >
                                                                            <div
                                                                                style={{
                                                                                    lineHeight: "normal"
                                                                                }}
                                                                                className='d-flex flex-column align-items-center'
                                                                            >
                                                                                <small
                                                                                    style={{
                                                                                        opacity: "0.4"
                                                                                    }}
                                                                                    className={`smallTagColor-${theme}`}
                                                                                >
                                                                                    Investment
                                                                                </small>
                                                                                <p
                                                                                    style={{
                                                                                        fontWeight: 600
                                                                                    }}
                                                                                    className='mb-0 text-primary table_heading_large'>
                                                                                    <small
                                                                                        className='xSmall'
                                                                                    >
                                                                                        Rs.
                                                                                    </small>
                                                                                    {
                                                                                        numberWithCommas(item?.total_amount?.toString()?.includes(".") ?
                                                                                            item?.total_amount?.toString()?.split(".")[0] :
                                                                                            item?.total_amount || 0)
                                                                                    }
                                                                                    <small className='xSmall'>
                                                                                        .{
                                                                                            item?.total_amount?.toString()?.includes(".") ?
                                                                                                item?.total_amount?.toString()?.split(".")[1] :
                                                                                                "00"
                                                                                        }
                                                                                    </small>
                                                                                </p>
                                                                                <small
                                                                                    className='text-info small_heading'
                                                                                >
                                                                                    @ {item?.avg_cost_per_unit || 0}
                                                                                </small>
                                                                            </div>
                                                                        </div>

                                                                        <div
                                                                        >
                                                                            <div
                                                                                style={{
                                                                                    lineHeight: "normal"
                                                                                }}
                                                                                className='d-flex flex-column align-items-center'
                                                                            >
                                                                                <small
                                                                                    style={{
                                                                                        opacity: "0.4"
                                                                                    }}
                                                                                    className={`smallTagColor-${theme}`}
                                                                                >
                                                                                    Current Size
                                                                                </small>
                                                                                <p
                                                                                    style={{
                                                                                        fontWeight: 600
                                                                                    }}
                                                                                    className='mb-0 text-primary table_heading_large'>
                                                                                    <small
                                                                                        className='xSmall'
                                                                                    >
                                                                                        Rs.
                                                                                    </small>
                                                                                    {
                                                                                        numberWithCommas(currentSize?.toString()?.includes(".") ?
                                                                                            currentSize?.toString()?.split(".")[0] :
                                                                                            currentSize || 0)
                                                                                    }
                                                                                    <small className='xSmall'>
                                                                                        .{
                                                                                            currentSize?.toString()?.includes(".") ?
                                                                                                currentSize?.toString()?.split(".")[1] :
                                                                                                "00"
                                                                                        }
                                                                                    </small>
                                                                                </p>
                                                                                <small
                                                                                    className='text-info small_heading'
                                                                                >
                                                                                    @ {item?.current_price || 0}
                                                                                </small>
                                                                            </div>
                                                                        </div>

                                                                        <div
                                                                        >
                                                                            <div
                                                                                style={{
                                                                                    lineHeight: "normal"
                                                                                }}
                                                                                className='d-flex flex-column align-items-center'
                                                                            >
                                                                                <small
                                                                                    style={{
                                                                                        opacity: "0.4"
                                                                                    }}
                                                                                    className={`smallTagColor-${theme}`}>
                                                                                    Return
                                                                                </small>
                                                                                <p style={{
                                                                                    fontWeight: 600, color: ReturnValu > 0 ?
                                                                                        "#05bd64" :
                                                                                        ReturnValu < 0 ?
                                                                                            "#de4f45" :
                                                                                            "#7ac6e1"
                                                                                }}
                                                                                    className='mb-0 table_heading_large'>
                                                                                    <small
                                                                                        className='xSmall'
                                                                                    >
                                                                                        Rs.
                                                                                    </small>
                                                                                    {
                                                                                        numberWithCommas(ReturnValu?.toString()?.includes(".") ?
                                                                                            ReturnValu?.toString()?.split(".")[0] :
                                                                                            ReturnValu || 0)
                                                                                    }
                                                                                    <small
                                                                                        className='xSmall'
                                                                                    >
                                                                                        .{
                                                                                            ReturnValu?.toString()?.includes(".") ?
                                                                                                ReturnValu?.toString()?.split(".")[1] :
                                                                                                "00"
                                                                                        }
                                                                                    </small>
                                                                                </p>
                                                                                <small
                                                                                    style={{
                                                                                        color: ReturnValuPercentage > 0 ?
                                                                                            "#05bd64" :
                                                                                            ReturnValuPercentage < 0 ?
                                                                                                "#de4f45" :
                                                                                                "#7ac6e1"
                                                                                    }}
                                                                                >
                                                                                    {Math.min(ReturnValuPercentage, 100)}%
                                                                                </small>
                                                                            </div>
                                                                        </div>

                                                                        <div
                                                                            style={{
                                                                                lineHeight: "normal"
                                                                            }}
                                                                            className='d-flex flex-column w-100'
                                                                        >
                                                                            <small
                                                                                style={{
                                                                                    opacity: "0.4"
                                                                                }}
                                                                                className={`smallTagColor-${theme}`}>
                                                                                Fund
                                                                            </small>
                                                                            <p
                                                                                style={{
                                                                                    fontWeight: 600
                                                                                }}
                                                                                className='mb-0 text-primary table_heading_large'>
                                                                                {item?.fund_code}
                                                                            </p>
                                                                            <small
                                                                                style={{
                                                                                    whiteSpace: "break-spaces"
                                                                                }}
                                                                                className='text-info'>
                                                                                {item?.fund_name}
                                                                            </small>
                                                                        </div>

                                                                    </div>
                                                                </Col>
                                                            )
                                                        })}

                                                    </Row>
                                                    <div className='d-flex justify-content-center'>
                                                        {itemsToShow < psxList.length && (
                                                            <div className='d-flex justify-content-center my-2'>
                                                                <Button
                                                                    size="md"
                                                                    id='hoverNoEffect'
                                                                    style={{
                                                                        background: "none"
                                                                    }}
                                                                    className=' border border-primary'
                                                                    onClick={handleShowMore}

                                                                >
                                                                    Show More
                                                                </Button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </Col>
                                        )
                                        :
                                        <div className='d-flex justify-content-center'>
                                            No Result Found
                                        </div> :
                                    <div className="d-flex justify-content-center my-3 w-100">
                                        <i
                                            className="fa fa-spinner fa-spin fa-3x"
                                            aria-hidden="true"
                                        ></i>
                                    </div>
                                }

                            </div>
                            <div className='card-footer'>
                                <div
                                    className='d-flex flex-wrap'
                                    style={{
                                        gap: "12px"
                                    }}
                                >
                                    {AbbreviationArr?.map((abb, i) => {
                                        return (
                                            <div
                                                key={i}
                                                className='d-flex align-items-baseline'
                                                style={{
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                {abb?.name}:
                                                <small className='ml-1'>{abb?.Abbreviation}</small>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </Container>
                </Col>
            </Row>
        </div >
    )
}

export default Profile